
import React, { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { client } from "../.."
import { showErrorMessage } from "../../helper/helper"
import { GetEncodeInvoiceUrl } from "../../api/invoice "

export const PempemDecodeUrl: React.FC = () => {
    const [param] = useSearchParams()
    const pdfUrlParam = param.get("pdfUrl")
    const orgId = param.get("orgId")
    const navigate = useNavigate()

    const getSignedUrl = async () => {
        client.query({
            query: GetEncodeInvoiceUrl,
            variables: {
                input: {
                    organisation_id: parseInt(orgId),
                    public_url: decodeURIComponent(pdfUrlParam)
                }
            }
        }).then(result => {
            navigate(`/explorer/invoice_pempem_detail?orgId=${orgId}&pdfUrl=${encodeURIComponent(result.data.url)}`, {replace: true})
        }).catch(e => {
            showErrorMessage(e)
            navigate(-1)
        })
    }

    useEffect(() => {
        getSignedUrl()
    }, [])

    return <></>
}
